import { getStepFieldValue, logDocumentEvent, getFormValues } from '../utils';
//import useAutomation from '../../../automation';
//import { AUTOMATION_ACTION_TYPE } from '../../../automation';
import { useSelector } from 'react-redux';
import { getDataLinkPath } from '../../../page/utils';
import { defaultDoc } from '../../../../utils/Schema';
import useParse from '../../../parse';
import {
  serverTimestamp,
  collection,
  Timestamp,
  setDoc,
  getFirestore
} from 'firebase/firestore';
import useDataLinkDatabase from '../../../database/datalink';
import { doc } from 'firebase/firestore';

const useCreate = () => {
  //const { onDocumentAction } = useAutomation();
  const { parse } = useParse();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const { getDb, getDatabaseId } = useDataLinkDatabase();

  const createDocument = async ({
    page,
    sequence,
    step,
    data = {},
    documents,
    selections,
    local,
    history,
    params
  }) => {
    const pageDataLink = page.dataLinks.find(
      d => d.dataLinkId === step.createDocumentDataLinkId
    );

    if (!pageDataLink) {
      return {
        error: `sequence "${sequence.name}", step: ${step.name} cannot be processed because the data link with id ${step.createDocumentDataLinkId} set against the step cannot be found.`
      };
    }
    const contentTypeToCreate = pageDataLink.dataLink.contentType;

    let defDoc = defaultDoc(contentTypeToCreate, 0, {}, user);

    defDoc.lastUpdatedBy = user?.email ? user.email : '';
    defDoc.createdAt = serverTimestamp();
    defDoc.updatedAt = serverTimestamp();
    delete defDoc.id;

    let newData = {};

    let inputs = getFormValues({
      formId: step.formId,
      returnObject: true
    });

    Object.keys(inputs).forEach(k => {
      if (!k || k === '') {
        delete inputs[k];
      }
    });

    if (inputs.error) {
      inputs = {};
    }

    const sourceData = {
      //...data,
      ...inputs
    };

    if (
      sourceData &&
      Object.keys(sourceData).length > 0 &&
      step.fields?.some(f => f.value.toString().indexOf('{data.') > -1)
    ) {
      // if any of the step fields are using data... then instead of simply spreading all of data
      // into the new document, we extract just the fields we want.
      step.fields
        .filter(f => f.value.toString().indexOf('{data.') > -1)
        .forEach(f => {
          newData[f.name] =
            sourceData[f.value.replace('{data.', '').replace('}', '')];
        });
    } else {
      newData = { ...sourceData };
    }

    step.fields
      ?.filter(f => f.value.toString().indexOf('{data.') === -1)
      .forEach(stepField => {
        const underlyingField = contentTypeToCreate?.fields?.find(
          f => f.name === stepField.name
        );

        const fieldValue = getStepFieldValue({
          stepField,
          underlyingField,
          selections,
          history,
          documents,
          user,
          local,
          dataLinks,
          data,
          params
        });

        // make sure text fields are no co-erced to numbers if the contain number strings
        if (Object.prototype.toString.call(fieldValue) === '[object Object]') {
          newData[
            stepField.dynamicFieldName?.trim().length > 0
              ? stepField.dynamicFieldName
              : stepField.name
          ] = fieldValue;
        } else if (stepField.dynamicFieldName?.trim().length > 0) {
          const targetField = parse({
            local,
            markup: stepField.dynamicFieldName,
            actionSequenceExecutionHistory: history,
            data,
            params
          });
          newData[targetField] = fieldValue;
        } else if (underlyingField?.type === 'string' && fieldValue?.toString) {
          newData[
            stepField.dynamicFieldName?.trim().length > 0
              ? stepField.dynamicFieldName
              : stepField.name
          ] = fieldValue.toString();
        } else if (stepField.fieldType === 'datetime') {
          if (fieldValue !== undefined && fieldValue !== '') {
            try {
              let dt = new Date(fieldValue);
              dt = Timestamp.fromDate(dt);
              if (!isNaN(dt.seconds) && !isNaN(dt.nanoseconds)) {
                newData[
                  stepField.dynamicFieldName?.trim().length > 0
                    ? stepField.dynamicFieldName
                    : stepField.name
                ] = dt;
              }
            } catch {
              // na
            }
          }
        } else {
          newData[
            stepField.dynamicFieldName?.trim().length > 0
              ? stepField.dynamicFieldName
              : stepField.name
          ] = fieldValue;
        }
      });

    defDoc = {
      ...defDoc,
      ...newData,
      sortOrder: documents[pageDataLink.dataLinkId]?.documents?.length + 1 || 1
    };

    /*if (step.createDocumentParentDataSourceId) {
      const parentDataSource = datasources.find(
        d => d.id === step.createDocumentParentDataSourceId
      );
      if (parentDataSource) {
        const parentType = types.find(t => t.type === parentDataSource.type);
        if (parentType) {
          const relationship = parentType.relationships.find(
            r => r.contentTypeName === contentTypeToCreate.type
          );
          if (
            relationship &&
            selections[step.createDocumentParentDataSourceId]
          ) {
            defDoc[relationship.childKey] =
              selections[step.createDocumentParentDataSourceId].documentId;
          }
        }
      }
    }*/

    const path = getDataLinkPath({
      dataLink: pageDataLink.dataLink,
      documents,
      selections,
      user,
      local,
      dataLinks,
      data,
      params
    });

    /*console.log(
      `loading datalink ${pageDataLink.name} from databaseId ${pageDataLink.databaseId} at ${path}`
    );*/

    const db = getDb(pageDataLink.dataLinkId);
    const databaseId = getDatabaseId(pageDataLink.dataLinkId);

    if (!defDoc.id) {
      const newRef = doc(collection(db, path));
      defDoc = {
        ...defDoc,
        id: contentTypeToCreate.type === 'user' ? defDoc.userID : newRef.id
      };
    }

    try {
      // replace any "true" or "false" with proper booleans
      Object.keys(defDoc).forEach(key => {
        if (defDoc[key]?.toLowerCase) {
          if (defDoc[key].toLowerCase().trim() === 'true') {
            defDoc[key] = true;
          } else if (defDoc[key].toLowerCase().trim() === 'false') {
            defDoc[key] = false;
          }
        }
      });

      await setDoc(doc(db, path, defDoc.id), defDoc, {
        merge: true
      });

      if (step.logDocumentEvent) {
        await logDocumentEvent({
          db: getFirestore(),
          databaseId,
          contentTypeName: contentTypeToCreate.type,
          documentAction: 'onDocumentCreated',
          documentId: defDoc.id,
          path: `${path}/${defDoc.id}`,
          after: defDoc,
          source: `actions.steps.create:\r\npage.id: ${page.id}\r\npage.name: ${page.name}\r\nsequence.id: ${sequence.id}\r\nsequence.name: ${sequence.name}\r\nstep.id: ${step.id}\r\nstep.name: ${step.name}`
        });
      }
    } catch (error) {
      return {
        error: `could not log create document event: ${error.toString()}`,
        path,
        document: defDoc
      };
    }

    // We are doing this here because we cannot access the latest version of the store data
    // whilst running in the action sequencer because of closures. Since documents is passed by reference
    // from the action sequencer, we append the new document here so that other steps in a sequence
    // have access to the new created document
    if (!documents[step.createDocumentDataLinkId]) {
      documents[step.createDocumentDataLinkId] = {
        type: contentTypeToCreate.type,
        documents: []
      };
    }
    documents[step.createDocumentDataLinkId].documents.push(defDoc);

    /*
    await onDocumentAction({
      action: AUTOMATION_ACTION_TYPE.RECORD_CREATED,
      id: docData.id,
      document: docData,
      contentType: contentTypeToCreate,
      path: `${path}/${docData.id}`
    });
    */

    return defDoc;
  };

  return {
    createDocument
  };
};

export default useCreate;
